/** The platform maker's supplied vector mark, static in credits and animated at platform entry points. */
import "@mhmo91/schmancy/thinking-bubble";
import "@mhmo91/schmancy/link";
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { theme } from "@mhmo91/schmancy/theme";
import { css, html } from "lit";
import { property, state } from "lit/decorators.js";
import { takeUntil } from "rxjs";
import horizontalDark from "./revia-logo/horizontal-dark.svg?raw";
import horizontalLight from "./revia-logo/horizontal-light.svg?raw";
import iconDark from "./revia-logo/icon-dark.svg?raw";
import iconLight from "./revia-logo/icon-light.svg?raw";

@schmancyElement("revia-logo")
export class ReviaLogo extends SchmancyElement {
	static styles = [
		css`
		:host { display: inline-block; width: 5rem; vertical-align: middle; }
		:host([animated]) { display: block; aspect-ratio: 1; }
		:host([compact]) { width: 2.5rem; }
	`,
	];

	@property({ type: Boolean, reflect: true }) animated = false;
	@property({ type: Boolean, reflect: true }) compact = false;
	@property({ type: Boolean }) unlinked = false;
	@property({ type: String }) scheme: "auto" | "light" | "dark" = "auto";
	@state() private resolvedScheme: "light" | "dark" = "light";

	override connectedCallback() {
		super.connectedCallback();
		theme.resolvedScheme$
			.pipe(takeUntil(this.disconnecting))
			.subscribe((scheme) => {
				this.resolvedScheme = scheme;
			});
	}

	override render() {
		const dark =
			(this.scheme === "auto" ? this.resolvedScheme : this.scheme) === "dark";
		const svg = this.compact
			? dark
				? iconDark
				: iconLight
			: dark
				? horizontalDark
				: horizontalLight;
		const mark = this.animated
			? html`<schmancy-thinking-bubble class="block !h-full !w-full" .startSvg=${svg} word-motion="breath" loop aria-hidden="true"></schmancy-thinking-bubble>`
			: html`<img class="block h-full w-full object-contain" src=${`data:image/svg+xml,${encodeURIComponent(svg)}`} alt="" />`;
		return this.unlinked
			? html`<span class="block h-full w-full" role="img" aria-label="ReVia">${mark}</span>`
			: html`<schmancy-link standalone href="https://revia.to/" target="_blank" .ariaLabel=${"ReVia"} class="block h-full w-full">${mark}</schmancy-link>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"revia-logo": ReviaLogo;
	}
}
